import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppService } from 'src/app/utils/services/app.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { DataProvider } from 'src/providers/data/data';

@Component({
  selector: 'app-delete-comp',
  templateUrl: './delete-comp.component.html',
  styleUrls: ['./delete-comp.component.scss'],
})
export class AnnDeleteCompComponent implements OnInit, OnDestroy {
  [x: string]: any;
  public changePasswordForm: FormGroup;
  constructor(
    private router: Router,
    private renderer: Renderer2,
    private toastr: ToastrService,
    private appService: AppService,
    public data: DataProvider
  ) {}

  ngOnInit() {
    this.data.menuPageTitle = 'wf-announcement';
  }
  ngOnDestroy() {
    this.renderer.removeClass(
      document.querySelector('app-root'),
      'change-password-page'
    );
  }
  notification() {
    this.router.navigate(['/wf-announcement']);
  }
}
